import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-swiper-slide-index"]
const _hoisted_2 = ["src", "alt", "width", "height", "loading"]
const _hoisted_3 = ["src", "alt", "width", "height"]
const _hoisted_4 = ["innerHTML"]

import type Swiper from 'swiper';
import { ref, computed, onMounted, onUnmounted, watchEffect } from 'vue';
import { linkify } from '@/js/lib/helper/linkify';
import { dynamicImageUrl } from '@/js/lib/helper/url';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhotoDialog',
  props: {
    pictures: { default: () => [] },
    currentIndex: { default: 0 },
    isShowModal: { type: Boolean },
    injectStyles: { default: () => [] }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const wrapperRef = ref();
const isMounted = ref(false);
const swiper = ref<Swiper>();
const current = ref(0);
const isShow = computed(() => props.isShowModal);
const comment = computed(() => props.pictures[current.value].comment);

onMounted(() => {
  isMounted.value = true;
});
onUnmounted(() => {
  swiper.value?.destroy();
});

watchEffect(() => {
  if (!swiper.value && isMounted.value && isShow.value && props.pictures.length > 1) {
    Object.assign(wrapperRef.value, {
      navigation: true,
      zoom: true,
      initialSlide: props.currentIndex,
      injectStyles: props.injectStyles,
    });

    wrapperRef.value.addEventListener('swiperprogress', (e: { detail: [Swiper, number] }) => {
      [swiper.value] = e.detail;
    });
    wrapperRef.value.addEventListener('swiperslidechange', () => {
      current.value = swiper.value!.realIndex;
      emit('change', current.value);
    });
    wrapperRef.value.initialize();
    // The number of slides is not enough for loop mode エラーを回避するための遅延処理
    setTimeout(() => {
      Object.assign(wrapperRef.value, {
        loop: true,
      });
    }, 500);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.wrapper)
    }, [
      (isShow.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style.photoPager)
          }, [
            _createElementVNode("p", null, _toDisplayString(`${current.value + 1} / ${_ctx.pictures.length}`), 1)
          ], 2))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("swiper-container", {
        ref_key: "wrapperRef",
        ref: wrapperRef,
        init: "false"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pictures, (picture, index) => {
          return (_openBlock(), _createElementBlock("swiper-slide", {
            key: index,
            "data-swiper-slide-index": index
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.dialog)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["swiper-zoom-container", _ctx.$style.imageWrap])
              }, [
                _createElementVNode("img", {
                  src: _unref(dynamicImageUrl)(picture.path, Math.min(picture.width, 1280)),
                  alt: picture.alt,
                  width: picture.width,
                  height: picture.height,
                  loading: current.value === index ? 'eager' : 'lazy'
                }, null, 8, _hoisted_2)
              ], 2)
            ], 2)
          ], 8, _hoisted_1))
        }), 128))
      ], 512)
    ], 2), [
      [_vShow, _ctx.pictures.length > 1]
    ]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (_ctx.pictures.length === 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.wrapper)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.dialog)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["swiper-zoom-container", _ctx.$style.imageWrap])
            }, [
              _createElementVNode("img", {
                src: _unref(dynamicImageUrl)(_ctx.pictures[0].path, Math.min(_ctx.pictures[0].width, 1280)),
                alt: _ctx.pictures[0].alt,
                width: _ctx.pictures[0].width,
                height: _ctx.pictures[0].height
              }, null, 8, _hoisted_3)
            ], 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (comment.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.dialogComment),
              innerHTML: _unref(linkify)(comment.value)
            }, null, 10, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})